<template>
  <div class="botTableWrap">
    <div class="componentWrap date_comp">
      <div class="bot_label"><v-icon>today</v-icon>일자별 리포트</div>
      <div class="table_wrap">
        <table class="bottom">
          <DaysImp
            :checkDate="checkDate"
            :clickDate="clickDate"
            :headers="headers"
            :isCreative="isCreative"
            :isExcel="isExcel"
            :tab="tab">
          </DaysImp>
          <DaysTotal
            :campaignType="campaignType"
            :campaginDaysData="campaginDaysData"
            :checkDate="checkDate"
            :clickDate="clickDate"
            :dataInfo="dataInfo"
            :isExcel="isExcel"
            :tab="tab">
          </DaysTotal>
        </table>
      </div>
    </div><!--
    --><ContentImp
      :headers="headers"
      :isExcel="isExcel"
      :tab="tab"></ContentImp>
  </div>
</template>

<script>
  import DaysImp from './DaysImp'
  import DaysTotal from './DaysTotal'
  import ContentImp from './ContentImp'

  export default {
    name: 'tableByDate',
    props: {
      // data props
      campaginDaysData: Array,
      campaignType: String,
      dataInfo: Array,
      tab: String,
      // function props
      checkDate: Function,
      clickDate: Function
    },
    components: {
      ContentImp,
      DaysImp,
      DaysTotal
    },
    data () {
      const headerss = this.tab === 'contract' || this.tab === 'creativeGroup' ? ['노출수', '클릭수', 'CTR(%)', '일광고비'] : ['노출수', '클릭수', 'CTR(%)']
      return {
        down: 'keyboard_arrow_down',
        up: 'keyboard_arrow_up',
        headers: headerss,
        isCreative: false,
        isExcel: false
      }
    }
  }
</script>

<style scoped>
  .table_wrap {
    width: 100%;
    overflow-x: auto;
  }
  .bot_label {
    position: absolute;
    top: -29px;
    left: 5px;
    height: 25px;
    font-weight: 500;
    color: #689f38;
    line-height: 25px;
  }
  .bot_label i {
    margin-right: 3px;
    font-weight: normal;
  }
  .icon {
    vertical-align: middle;
    color: #689f38;
    font-weight: bold;
  }
  .bottom {
    border-collapse: collapse;
    width: 100%;
    border-spacing: 0;
  }
  .componentWrap {
    background: #fff;
    border: 1px solid #d1dce3;
    border-radius: 7px;
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: calc(50% - 32px);
    margin-left: 10px;
    margin-right: 10px;
    padding: 5px 10px;
  }
  .componentWrap.date_comp {
    margin-left: 0;
  }
  td {
    height: 25px;
  }
  tfoot td, tfoot th {
    border-top: 1px solid #eaeaea
  }

  @media screen and (max-width: 600px) {
    .componentWrap {
      padding: 0;
      padding-top: 5px;
      margin-left: 0;
      margin-right: 0;
      width: calc(100% - 2px);
      /* text-align: center; */
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .bot_label {
      left: 10px;
    }
    .icon {
      margin-left: -5px;
    }
    .bottom {
      width: 100%;
      margin-left: 0;
      padding-bottom: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// dateTable.vue?2475f20c